var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppbarIconQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #0089cf;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #0089cf;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appbar-icon-question",
    transform: "translate(-330)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    className: "cls-1",
    width: 36,
    height: 44,
    transform: "translate(330)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_118",
    "data-name": "\\uADF8\\uB8F9 118",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_22",
    "data-name": "\\uD0C0\\uC6D0 22",
    className: "cls-2",
    transform: "translate(337 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11,
    cy: 11,
    r: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_53",
    "data-name": "\\uD328\\uC2A4 53",
    className: "cls-3",
    d: "M-1.094-2.683v.16H.824v-.16A2.01,2.01,0,0,1,2.015-4.659,2.807,2.807,0,0,0,3.585-7.187c0-1.794-1.431-2.848-3.458-2.848-1.86,0-3.378.981-3.415,3.022h2.063A1.3,1.3,0,0,1,.112-8.321,1.2,1.2,0,0,1,1.376-7.115C1.383-6.446.9-6,.272-5.589-.6-5.044-1.087-4.492-1.094-2.683ZM-1.312-.46A1.2,1.2,0,0,0-.091.761,1.225,1.225,0,0,0,1.115-.46,1.212,1.212,0,0,0-.091-1.666,1.193,1.193,0,0,0-1.312-.46Z",
    transform: "translate(347.852 27.637)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppbarIconQuestion);
export default __webpack_public_path__ + "static/media/appbar-icon-question.9e49bc79b5dab003f4449f7b5b5ec8ca.svg";
export { ForwardRef as ReactComponent };